/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-09 10:58:57
 * @LastEditors: caiqin.xie
 * @message: 最新博客
 */
import React from "react";
import BlogItem from "../../../components/BlogItem";
import styles from "../../index.module.scss";
import { IBlogItem } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  newsList: IBlogItem[]; // 最新博客
}

const RelatedNews = (props:IProps) => {
  const {ctry, words, newsList} = props

  return (
    <div className={styles['blog-right-bottom']}>
      <h3>{words?.blog_news_title}</h3>
      {/* New Release */}
      <div className={styles['blog-list']}>
        {newsList && newsList.map((item, index) => (
          <a key={item.id} href={`/${ctry}/blog/${item.seoUrl}`} className={styles['link-blog']}>
            <BlogItem
              key={item.id}
              type='onlyTitle'
              blogData={item}
              className={styles['custom-blog']}
              picClassName={styles['custom-blog-pic']}
              itemClassName={styles['custom-blog-item']} />
          </a>
        ))}
      </div>
      <p className={styles['more-related-blog']}>
        <a href={`/${ctry}/blog`}>
          <span className={styles['more-blog']}>{words?.blog_see_all_articles}</span>
        </a>
        {/* See all articles */}
      </p>
    </div>
  )
}
export default RelatedNews
